import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import every from 'lodash/every';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Project } from 'records/Project';

interface Props extends RouteComponentProps {
  permissions: string[];
  redirectTo?: string;
}

interface State {
  hasPerms: boolean;
}

class HasPermissions extends React.Component<Props, State, AppStore> {
  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  constructor(props: Props, context: AppStore) {
    super(props, context);

    const { selectedProject, projects } = context.state;

    const { permissions } = projects.get(selectedProject, new Project());

    const hasPerms = every(props.permissions, (perm): boolean =>
      permissions.get(perm, false)
    );

    if (!hasPerms) {
      if (props.redirectTo) {
        props.history.push(props.redirectTo);
      }
    }

    this.state = {
      hasPerms,
    };
  }

  render(): React.ReactNode {
    return this.state.hasPerms ? this.props.children : null;
  }
}

export default withRouter(HasPermissions);
